const Box = ({ checked, label }) => (
  <span className="inline-flex items-center gap-1 mr-1.5 whitespace-nowrap">
    <span className="inline-flex items-center justify-center h-3.5 w-3.5 border border-black text-[10px] leading-none font-bold">
      {checked ? "X" : ""}
    </span>
    {label}
  </span>
);

const clientName = (c, a) =>
  (c && `${c.first_name || c.name || ""} ${c.last_name || ""}`.trim()) || a.title || "—";

function PrintTable({ title, list, clients, types, users }) {
  return (
    <section className="mb-5 break-inside-avoid-page">
      <h2 className="text-sm font-bold uppercase tracking-wide border-b-2 border-black pb-1 mb-1">
        {title} · {list.length} appuntamenti
      </h2>
      <table className="w-full border-collapse text-[10px]">
        <thead>
          <tr className="text-left">
            {["Ora", "Cliente", "Telefono", "Tipo / Collaboratore", "Mezzo", "Esito"].map((h) => (
              <th key={h} className="border border-black px-1.5 py-0.5 font-bold bg-gray-100">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {list.map((a) => {
            const c = clients.find((x) => x.id === a.client_id);
            const t = types.find((x) => x.id === a.appointment_type_id);
            const u = users.find((x) => x.id === a.collaborator_id);
            return (
              <tr key={a.id} className="break-inside-avoid align-middle">
                <td className="border border-black px-1.5 py-0.5 font-mono font-bold">
                  {new Date(a.start).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}
                </td>
                <td className="border border-black px-1.5 py-0.5 font-semibold">{clientName(c, a)}</td>
                <td className="border border-black px-1.5 py-0.5 font-mono whitespace-nowrap">{c?.phone || ""}</td>
                <td className="border border-black px-1.5 py-0.5 whitespace-nowrap">
                  {t?.name || ""}{u?.name && <span className="text-gray-600"> · {u.name}</span>}
                </td>
                <td className="border border-black px-1.5 py-0.5 whitespace-nowrap">
                  <Box checked={a.reminder_method === "phone"} label="Tel." />
                  <Box checked={a.reminder_method === "whatsapp"} label="WA" />
                </td>
                <td className="border border-black px-1.5 py-0.5 whitespace-nowrap">
                  <Box checked={a.reminder_outcome === "ok"} label="Contattato" />
                  <Box checked={a.reminder_outcome === "no_answer"} label="Non risp." />
                  <Box checked={a.reminder_outcome === "unreachable"} label="Non ragg." />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
}

export function ReminderPrintSheet({ headerLabel, groups, clients, types, users }) {
  const total = groups.consulenti.length + groups.trainers.length;
  return (
    <div className="hidden print:block text-black bg-white" data-testid="reminders-print-sheet">
      <style>{`@page { size: A4 portrait; margin: 8mm; }`}</style>
      <div className="flex items-end justify-between border-b border-black pb-2 mb-4">
        <div>
          <div className="text-lg font-bold">Chiamate Clienti</div>
          <div className="text-sm capitalize">{headerLabel}</div>
        </div>
        <div className="text-sm">Totale appuntamenti: <strong>{total}</strong> · Operatore: ____________________</div>
      </div>
      {total === 0 && <p className="text-sm">Nessun appuntamento in questa giornata.</p>}
      {groups.consulenti.length > 0 && (
        <PrintTable title="Calendario Consulenti" list={groups.consulenti} clients={clients} types={types} users={users} />
      )}
      {groups.trainers.length > 0 && (
        <PrintTable title="Calendario Trainers" list={groups.trainers} clients={clients} types={types} users={users} />
      )}
    </div>
  );
}
